import { createAction } from '@reduxjs/toolkit';

export const fetchSiteMessage = createAction('siteMessage/FETCH_SITE_MESSAGE');
export const setSiteMessage = createAction('siteMessage/SET_SITE_MESSAGE');
export const clearSiteMessage = createAction('siteMessage/CLEAR_SITE_MESSAGE');
